import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { TypeHouseOccupation } from 'shell/models/type-house-occupation';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ListHouseOccupationProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const ListHouseOccupationComponent = ({
  disabled,
  required,
  onChange,
  value,
  label = 'Tipo occupazione abitazione',
  error,
  id = 'type-occupation',
}: ListHouseOccupationProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<TypeHouseOccupation>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/anpr/tipo-occupazione-abitazione`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeHouseOccupation>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codice?.toString() || '',
          value: item.nome || '',
        }));
      },
    }
  );

  const dataList = (list.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`${id}-label`}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataList?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListHouseOccupationComponent.displayName = 'List house occupation component';

const ListHouseOccupation = memo(ListHouseOccupationComponent);

export default ListHouseOccupation as typeof ListHouseOccupationComponent;
